<div class="ticket-analysis-container w-100">
  <div class="ticket-analysis-header-container">
    <div class="ticket-analysis-header w-100 d-flex align-items-center pl-4">
      <span class="ticket-analysis-header-title">TICKET ANALYSIS</span>
      @if (currentDashboard) {
        <span class="ticket-analysis-header-separator"> | </span>
        <span class="ticket-analysis-header-subtitle">{{ currentDashboard }}</span>
      }
      <button
        class="ticket-analysis-export-btn d-flex align-items-center justify-content-center"
        [class.dark-mode]="isDarkMode"
        [class.ticket-analysis-export-btn--completed]="exportState.status === 'completed'"
        [class.ticket-analysis-export-btn--failed]="exportState.status === 'failed'"
        [disabled]="exportState.status === 'pending'"
        [matTooltip]="exportTooltip"
        (click)="onExportClick()"
      >
        <mat-spinner *ngIf="exportState.status === 'pending'" diameter="20"></mat-spinner>
        <img *ngIf="exportState.status !== 'pending'" width="18px" alt="Export" />
      </button>
    </div>
    <hr class="my-0 py-0 mx-2" />
  </div>
  <div class="h-100 overflow-hidden ticket-analysis-content">
    <router-outlet></router-outlet>
  </div>
</div>
